export const getClientSlugFromHostname = (hostname: string): string | undefined => {
  const normalisedHostname = hostname.trim().toLowerCase()
  if (!normalisedHostname) {
    return undefined
  }

  if (
    normalisedHostname === 'localhost' ||
    normalisedHostname.startsWith('localhost:') ||
    normalisedHostname === '127.0.0.1' ||
    normalisedHostname.startsWith('127.0.0.1:')
  ) {
    return undefined
  }

  if (normalisedHostname.endsWith('.netlify.app')) {
    return undefined
  }

  const hostParts = normalisedHostname.split('.').filter(Boolean)
  if (hostParts.length < 3) {
    return undefined
  }

  const rootDomain = hostParts.slice(-2).join('.')
  if (rootDomain !== 'hopd.app') {
    return undefined
  }

  const subdomain = hostParts[0]
  if (!subdomain || subdomain === 'www') {
    return undefined
  }

  return subdomain
}
